var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFormasDePago(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00347B"
    },
    d: "M426.073,236.577H72.134c-7.968,0-14.427-6.58-14.427-14.697V65.829    c0-18.524,14.794-33.594,32.977-33.594h316.839c18.184,0,32.977,15.07,32.977,33.594V221.88    C440.5,229.997,434.041,236.577,426.073,236.577z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE277"
    },
    d: "M349.854,358.5H32.939C14.776,358.5,0,343.447,0,324.946V124.576    c0-18.502,14.776-33.554,32.939-33.554h316.916c18.162,0,32.939,15.053,32.939,33.554v200.369    C382.793,343.447,368.016,358.5,349.854,358.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCB00"
    },
    d: "M349.854,91.022H192.333V358.5h157.521c18.162,0,32.939-15.052,32.939-33.554V124.576   C382.793,106.074,368.016,91.022,349.854,91.022z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 149.741,
    style: {
      fill: "#FFF3F3"
    },
    width: 382.793,
    height: 66.135
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.333,
    y: 149.741,
    style: {
      fill: "#E9DFDA"
    },
    width: 190.459,
    height: 66.135
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ECCF"
    },
    d: "M382.372,479.765c-3.185,0-6.369-1.011-9.045-3.034l-80.46-60.821    c-26.319-19.896-40.231-52.477-40.231-94.219v-92.958c0-5.893,3.451-11.24,8.82-13.668l114.683-51.854    c3.929-1.775,8.433-1.776,12.361,0.001l114.682,51.87c5.368,2.429,8.818,7.774,8.818,13.667v92.975    c0,41.718-13.896,74.283-40.187,94.177l-80.391,60.827C388.746,478.752,385.559,479.765,382.372,479.765z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00CAB1"
    },
    d: "M503.182,215.081L388.5,163.211c-1.809-0.819-3.741-1.242-5.682-1.306v317.843   c3.037-0.09,6.053-1.09,8.605-3.021l80.391-60.827C498.104,396.006,512,363.44,512,321.723v-92.975   C512,222.855,508.55,217.51,503.182,215.081z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF3F3"
    },
    d: "M369.407,371.666c-5.537,0-11.073-2.111-15.297-6.337l-33.959-33.959    c-8.449-8.448-8.449-22.146,0-30.594c8.448-8.448,22.146-8.448,30.594,0l18.662,18.662l55.662-55.66    c8.449-8.448,22.148-8.451,30.594,0c8.449,8.448,8.448,22.146,0,30.594l-70.959,70.958    C380.481,369.554,374.943,371.666,369.407,371.666z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9DFDA"
    },
    d: "M455.664,263.778c-8.447-8.451-22.145-8.448-30.594,0l-42.251,42.25v60.966   c0.651-0.516,1.285-1.063,1.887-1.664l70.959-70.958C464.111,285.924,464.113,272.226,455.664,263.778z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormasDePago);
export default __webpack_public_path__ + "static/media/formas_de_pago.d4d5d13337d8e83f65704f0f67650c44.svg";
export { ForwardRef as ReactComponent };